import { fetchJson, getApiURL, buildQueryString } from 'helpers/wordpress'

const getCategoryIDBySlug = async (slug, queryParams = {}) => {
    const params = { ...queryParams, slug }
    const { data = [{}] } = await fetchJson(`${getApiURL('categories')}?${buildQueryString(params)}`)
    return data[0].id || 1
}

export default getCategoryIDBySlug
